<div class="date-range-filter" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px" fxLayout.lt-sm="column" fxFlex>
  <mat-form-field appearance="outline" class="custom-mat-field" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>{{ 'DATE_RANGE.FROM' | translate }}</mat-label>
      <input matInput [matDatepicker]="fromPicker" [(ngModel)]="fromDate" (ngModelChange)="onDateChange()"
             [max]="toDate" name="fromDate" required>
      <mat-datepicker-toggle dateFormat="dd/mm/yyyy" matSuffix [for]="fromPicker"></mat-datepicker-toggle>
      <mat-datepicker #fromPicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline" class="custom-mat-field" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>{{ 'DATE_RANGE.TO' | translate }}</mat-label>
      <input matInput [matDatepicker]="toPicker" [(ngModel)]="toDate" (ngModelChange)="onDateChange()"
             [min]="fromDate" name="toDate" required>
      <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
      <mat-datepicker #toPicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline" class="custom-mat-field" fxFlex="30" fxFlex.lt-md="100">
      <mat-label>{{ 'DATE_RANGE.PERIOD' | translate }}</mat-label>
      <mat-select [(ngModel)]="selectedPeriod" (ngModelChange)="onPeriodChange($event)">
          <mat-option *ngFor="let period of periods" [value]="period.value">
              {{ period.label | translate }}
          </mat-option>
      </mat-select>
  </mat-form-field>

  <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center" fxFlex="10" fxFlex.lt-md="100" fxLayoutAlign.lt-md="end center">
      <button mat-icon-button type="button" id="btn-refresh" (click)="resetFilter()" 
              [matTooltip]="'DATE_RANGE.RESET' | translate">
          <mat-icon style="color: #039be5;">refresh</mat-icon>
      </button>
      <button mat-icon-button type="button" id="btn-filter" (click)="clearFilter()" 
              [matTooltip]="isFilterActive ? ('DATE_RANGE.CLEAR_FILTER' | translate) : ('DATE_RANGE.APPLY_FILTER' | translate)">
          <mat-icon [ngStyle]="{'color': isFilterActive ? '#039be5' : 'inherit'}">filter_list</mat-icon>
      </button>
  </div>
</div>